// AI-CONTEXT: See docs/features/analytics-card-redesign.md
//
// Single source of truth for the effect "score system": the two scores —
// result / benchmark — each get a fixed brand colour AND a fixed line style,
// so they're recognisable both in the score block and inside the chart.
//
//   result  Jouw resultaat (gemeten)   teal #47acc3   solid line
//   bench    Benchmark (extern)         coral          dotted line
//
// Flip the palette here and the score block + chart legend all follow.

/** @typedef {'result' | 'bench'} ScoreKind */

/** @type {ScoreKind[]} */
export const SCORE_KINDS = ['result', 'bench']

/** Solid brand colour per score. @type {Record<ScoreKind, string>} */
export const SCORE_COLORS = {
    result: '#47acc3',
    bench: '#f48183',
}

/** Soft tints for pill/tag/cell backgrounds. @type {Record<ScoreKind, string>} */
export const SCORE_COLORS_SOFT = {
    result: '#e7f4f7',
    bench: '#fdecec',
}

/**
 * SVG / Recharts `stroke-dasharray` per score. Empty string = solid line.
 * @type {Record<ScoreKind, string>}
 */
export const SCORE_DASHARRAY = {
    result: '',
    bench: '2 5',
}

/** Dutch display label per score. @type {Record<ScoreKind, string>} */
export const SCORE_LABELS = {
    result: 'Jouw resultaat',
    bench: 'Benchmark',
}

/**
 * @param {string} kind
 * @returns {string | undefined} The brand colour for a score kind, or undefined.
 */
export const getScoreColor = (kind) => SCORE_COLORS[kind]
